import { FileRenderInfo } from "@sp-crm/core";
import { SecondaryButton } from "components/ui/secondary-button";
import { Spinner } from "components/ui/spinner";
import React, { FunctionComponent, useCallback, useRef, useState } from "react";
import "slick-carousel/slick/slick.css";
import { Header } from "../header";

const defaultImageRenderInfo: FileRenderInfo = {
    fileGroupIcon: "55_photos",
    fileGroupHeading: "Community Photos",
};

interface MultipleFileUploadProps {
    onAddNewFiles: (files: File[]) => Promise<void>;
    title?: string;
    includeByline?: boolean;
    urlPrefix?: string;
    imageRenderInfo?: FileRenderInfo;
}

export const MultipleFileUpload: FunctionComponent<MultipleFileUploadProps> = props => {
    const [isUploading, setUploading] = useState(false);
    const { onAddNewFiles, imageRenderInfo = defaultImageRenderInfo } = props;

    const handleAddNewFiles = useCallback(
        (files: File[]) => {
            setUploading(true);
            onAddNewFiles(files).then(() => {
                setUploading(false);
            });
        },
        [onAddNewFiles, setUploading],
    );

    return (
        <div className="input-form-block-no-bottom-margin multiple-image-uploader">
            <div className="empty-additional-contacts-section flex-row-no-bottom-margin">
                <div className="flex-column">
                    <div className="header-with-action">
                        <div className="header">
                            <Header iconName={imageRenderInfo.fileGroupIcon}>
                                {imageRenderInfo.fileGroupHeading}
                            </Header>
                        </div>
                    </div>
                </div>
                <div className="flex-row">
                    {isUploading ? (
                        <Spinner />
                    ) : (
                        <AddFileButton onAddNewFiles={handleAddNewFiles} />
                    )}
                </div>
            </div>
        </div>
    );
};

const AddFileButton: FunctionComponent<{
    onAddNewFiles: (files: File[]) => void;
}> = ({ onAddNewFiles }) => {
    const fileRef = useRef(null);

    const handleUpload = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const files = Array.from(event.target.files) as File[];
            if (files.length) {
                onAddNewFiles(files);
            }
        },
        [onAddNewFiles],
    );

    return (
        <div className="inline-block">
            <SecondaryButton
                title="Upload File"
                onClick={() => {
                    fileRef.current.click();
                }}>
                Upload File
            </SecondaryButton>
            <input
                type="file"
                ref={fileRef}
                className="hidden"
                accept="*"
                multiple
                onChange={handleUpload}
            />
        </div>
    );
};
